/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goals_OtherInputs */

const en_onboarding_goals_other = /** @type {(inputs: Onboarding_Goals_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const es_onboarding_goals_other = /** @type {(inputs: Onboarding_Goals_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Onboarding_Goals_OtherInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_goals_other = /** @type {((inputs?: Onboarding_Goals_OtherInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goals_OtherInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_goals_other(inputs)
	return en_onboarding_goals_other(inputs)
});